import QuestionnaireListingView from "./QuestionnaireListingView";

export default QuestionnaireListingView;
